import OfferEvent from '@core/models/offer/OfferEvent';
import { VideoProviderType } from '@models/offer/enums';

import {
    StreamSection,
    VideoProviderToStreamSection,
} from './sportPage/enums';

export function getMatchStreams(match: OfferEvent): StreamSection[] {
    if (!match.hasStream) {
        return [];
    }

    return Object.keys(match.streamInfo)
        // We want to filter the values we're not supporting on the web, e.g. 8 is IMG UFC Widget for native platforms
        .filter((key) => {
            const providerType = parseInt(key, 10);
            return Object.values(VideoProviderType).includes(providerType) && providerType !== VideoProviderType.IMG_VISUALIZATION_WIDGET;
        })
        .map((key) => VideoProviderToStreamSection[parseInt(key, 10) as VideoProviderType]);
}
